<template>
    <div class="header-section">
        <p class="form-subtitle" style="cursor: pointer;" @click="$router.push('/club-highlight-ext')">
            <i class="fa fa-arrow-left"></i> Back
        </p>
        <h1 class="form-title">Club Highlight 2nd Section</h1>
        <p class="form-subtitle">Set up club highlight and add the required details</p>
    </div>
    <form @submit.prevent="submitForm">
        <div class="setup-form">
            <div class="header">
                <div class="form-group">
                    <label for="tournamentName">Title</label>
                    <input type="text" placeholder="Enter title" required v-model="club_title" />
                </div>
                
            </div>
            <div class="header">
               
                <div class="form-group">
                    <label for="tournamentName">Description</label>
                    <!-- <textarea placeholder="Type description here..." rows="3" required v-model="club_description" /> -->
                    <editor
                        v-model="club_description"
                        id="uuid"
                        apiKey="x0n55hrl9tycjmw97mipnesynsnqm8uw0c2oby6coyvoafmz"
                        :init="{
                            plugins: 'advlist anchor autolink charmap code fullscreen help image insertdatetime link lists media preview searchreplace table visualblocks wordcount',
                            toolbar: 'undo redo | styles | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                            height: 300,
                        }"
                        />
                </div>
               
            </div>
        </div>
        <!-- File Upload Section -->
        <p style="color: #232321; font-weight: 600; font-size: 16px; text-align: center;">Image</p>
        <div @click="triggerFileInput" class="upload-section">
            <!-- Hidden input -->
            <input 
                type="file" 
                ref="fileInput" 
                class="hidden" 
                accept="image/jpeg, image/png" 
                multiple
                @change="handleFileChange" />

            <!-- Custom trigger -->
            <div>
                <Image size="32" style="margin-bottom: 10px;" />
                <p style="padding: 0%; margin: 0%;">Drop your imager here, or browse</p>
                <p style="padding: 0%; margin: 0%;">Jpeg, png are allowed</p>
            </div>
        </div>
        <!-- File list with progress -->
        <div class="file-list-section">
            <div class="file-item" v-for="file in files" :key="file.name">
                <img v-if="file.preview" :src="file.preview" alt="preview" class="file-preview" />

                <p class="file-name">
                    {{ file.name.replace(/\.[^/.]+$/, "") }}
                </p>
                <div class="progress-container">
                    <div class="progress-bar" :style="{ width: file.progress + '%' }"></div>
                </div>
                <CircleCheck v-if="file.progress === 100" style="color: #DB6813;" />
                <CircleCheck v-else style="color: #00000033;" />

            </div>
        </div>
        <div class="buttons">
            <button>Submit</button>
        </div>
    </form>
</template>
<script setup>
import { CircleCheck, Image } from "lucide-vue-next";
import { ref, reactive } from "vue";
import axios from 'axios';
import router from "@/router";
import Editor from '@tinymce/tinymce-vue'

const fileInput = ref(null);
const files = ref([]);
let club_title = ref('');
let club_description = ref('')
const created_by = ref(localStorage.getItem('userid'));

function triggerFileInput() {
    fileInput.value.click();
}

function handleFileChange(event) {
    const selectedFile = event.target.files[0]; // only one banner at a time

    if (selectedFile) {
        const fileObj = reactive({
            name: selectedFile.name,
            file: selectedFile,
            progress: 0,
            preview: selectedFile.type.startsWith("image/")
                ? URL.createObjectURL(selectedFile)
                : null
        });
        files.value = [fileObj]; // replace with new file
    }

    event.target.value = "";
}

async function submitForm() {
    if (!club_title.value || !club_description.value) {
        alert("Please fill in all fields.");
        return;
    }

    if (files.value.length === 0) {
        alert("Please select a banner image.");
        return;
    }

    const formData = new FormData();
    formData.append("title", club_title.value);
    formData.append("description", club_description.value);
    formData.append("created_by", created_by.value);
    formData.append("banner_image", files.value[0].file);

    try {
        const response = await axios.post(
            "/club_highlight_ext.php", // change to your backend URL
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (e) => {
                    if (files.value.length > 0) {
                        files.value[0].progress = Math.round(
                            (e.loaded * 100) / e.total
                        );
                    }
                }
            }
        );

        if (response.data.status) {
            alert("✅ " + response.data.message);
            club_title.value = "";
            club_description.value = "";
            files.value = [];
            router.push("/club-highlight-ext");
        } else {
            alert("❌ " + response.data.message);
        }
    } catch (error) {
        console.error(error);
        alert("❌ Upload failed. Please try again.");
    }
}
</script>
<style scoped>
.setup-form {
    max-width: 95%;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    justify-content: between;
    gap: 24px;
    align-items: start;
}

.header-section {
    max-width: 90%;
    margin: 0 auto 20px auto;
}

.header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    width: 50%;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    border: 1px solid #EBF1FF;
    border-radius: 20px;
    padding: 40px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: start;
    width: 100%;
    margin-top: 20px;
}

.form-group label {
    font-size: 16px;
    color: #495057;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
    resize: vertical;
}

.form-group input:focus {
    border-color: #4C6EF5;
}

.buttons {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 90%;
    margin: 0 auto 40px auto;
}

.buttons button {
    flex: 1;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s, color 0.3s;
}

.buttons button:first-child {
    background-color: #FF1F25;
    color: #fff;
}

.buttons button:first-child:hover {
    background-color: #c92f34;
    color: #fff;
}

.buttons button:last-child {
    background-color: #ED4E24;
    color: #fff;
}

.buttons button:last-child:hover {
    background-color: #d35533;
    color: #fff;
}

.form-title {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    color: #020617;
}

.form-subtitle {
    text-align: left;
    font-size: 16px;
    color: #020617;
    margin-bottom: 20px;
}

.upload-section {
    margin-top: 20px;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 12px;
    text-align: center;
    background: #fafafa;
    max-width: 90%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
}

.upload-section input[type="file"] {
    display: none;
}

.file-list-section {
    max-width: 90%;
    padding: 10px;
    margin: 15px auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.file-item {
    background-color: #FAFAFA;
    border: 1px solid #ccc;
    width: 50%;
    margin-top: 15px;
    text-align: left;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.file-name {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    padding: 0%;
    margin: 0%;
    width: 20%;
}

.progress-container {
    height: 4px;
    width: 80%;
    background: #eee;
    border-radius: 10px;
    position: relative;
}

.progress-bar {
    height: 100%;
    background: red;
    border-radius: 10px;
    transition: width 0.3s;
}

.progress-container span {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.file-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .setup-form {
        flex-direction: column;
        padding: 0px;
        max-width: 100%;
        margin: 0%;
    }

    .header {
        width: 100%;
        padding: 20px;
    }

    .buttons {
        flex-direction: column;
        width: 100%;
        margin: 0 auto 20px auto;
    }

    .upload-section {
        margin-top: 20px;
        padding: 20px;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }

    .file-list-section {
        max-width: 100%;
        padding: 8px;
        margin: 12px auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .file-item {
        background-color: #FAFAFA;
        border: 1px solid #ccc;
        width: 100%;
        margin-top: 15px;
        text-align: left;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

}
</style>